import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import './FileInputZolaUI.styles.less';

const FileInputZolaUIButton = ({
  btnClass,
  btnText,
  busy,
  busyOverride,
  callback,
  divClass,
  disabledOverride,
  inputId,
  onSelect,
  types,
}) => {
  const [busyState, setBusyState] = useState(false);

  const handleSelect = (e) => {
    const file = e.target;
    if (file && file.files.length > 0) {
      setBusyState(true);
      onSelect(file)
        .then(() => { if (callback) callback(); });
    }
  };

  const busySource = busyOverride ? busy : busyState;
  const className = cx('file-input-container', divClass);
  const labelClass = cx('zola-ui-imported', btnClass);

  return (
    <div className={className}>
      <label
        htmlFor={inputId}
        disabled={busySource || disabledOverride}
        className={labelClass}
      >
        {btnText || 'Upload'}
        <input
          id={inputId}
          type="file"
          onChange={handleSelect}
          disabled={busySource || disabledOverride}
          accept={types}
        />
      </label>
    </div>
  );
};

FileInputZolaUIButton.propTypes = {
  btnClass: PropTypes.string,
  btnText: PropTypes.string,
  busy: PropTypes.bool,
  busyOverride: PropTypes.bool,
  callback: PropTypes.func,
  divClass: PropTypes.string,
  inputId: PropTypes.string,
  disabledOverride: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  types: PropTypes.string.isRequired,
};

export default FileInputZolaUIButton;



// WEBPACK FOOTER //
// ./src/components/common/form/FileInputZolaUIButton.jsx